import img1 from "../images/1.jpg";
import img2 from "../images/5.jpg";
import img3 from "../images/3.jpg";
import img4 from "../images/4.jpg";
import img5 from "../images/8.jpg";
import img6 from "../images/2.jpg";

export const images = {
  img1,
  img2,
  img3,
  img4,
  img5,
  img6,
};
